export const TOKEN_EXCHANGE = 'identity/TOKEN_EXCHANGE'
